import { useLazyQuery } from "@apollo/client/react"; import React, { useMemo, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { SwitchInput } from '../../../../components/switchInput/SwitchInput';
import { TextInput } from '../../../../components/textInput/TextInput';
import { SelectInput } from '../../../../components/selectInput/SelectInput';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import {
  Button,
  Grid,
  Box
} from
  '@mui/material';
import { GET_CLIENTES } from '../../../../data/graphQL/queries/Planes/getClientes';
import { useDebounce } from '../../../../hooks/useDebounce';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { adaptClientesArray } from '../../../../adapters/clienteAdapter';

import { CustomButton } from '../../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';

import './stepClientes.scss';
export const BuscarClientes = ({ open, onClose, onRowClick, onEditRowClick, rowData, delegacionesData }) => {

  const [
    rows,
    handleChangePaginationStatus,
    paginationStatus,
    totalCount,
    filterStatus,
    setFilterStatus,
    delegacionStatus,
    setDelegacionStatus,
    setCodDelegacionStatus] =
    useGetClientes();

  const isNew = Boolean(!rowData.codigoSapCliente);

  const clienteInitial = {
    codigoSapCliente: '',
    nombre: '',
    requiereFacturacion: false,
    codigoEspCliente: '',
    atributo1: '',
    atributo2: '',
    atributo3: '',
    atributo4: '',
    atributo5: ''
  };

  const clienteEdit = {
    idPlanCuidado: rowData?.idPlanCuidado,
    codigoSapCliente: rowData?.codigoSapCliente,
    nombre: rowData?.nombre,
    requiereFacturacion: rowData?.requiereFacturacion,
    codigoEspCliente: rowData?.codigoEspCliente,
    atributo1: rowData?.atributo1,
    atributo2: rowData?.atributo2,
    atributo3: rowData?.atributo3,
    atributo4: rowData?.atributo4,
    atributo5: rowData?.atributo5
  };

  const [cliente, setCliente] = useState(isNew ? clienteInitial : clienteEdit);

  const [searchCliente, setSearchCliente] = useState(false);

  const initialColumns = [
    {
      field: 'cod',
      headerName: 'Código'
    },
    {
      field: 'nombre',
      headerName: 'Cliente'
    },
    {
      field: 'cuit',
      headerName: 'Cuit'
    },
    {
      field: 'domicilio',
      headerName: 'Domicilio'
    },
    {
      field: 'cp',
      headerName: 'CP'
    }];



  useEffect(() => {
    setSearchCliente(false);
    if (delegacionesData) {
      setDelegacionStatus(delegacionesData[0]?.id);
      setCodDelegacionStatus(delegacionesData);
    }
    if (!isNew) {
      setCliente(rowData);
      setFilterStatus(rowData.codigoSapCliente);
    } else {
      setCliente(clienteInitial);
    }
  }, [rowData, delegacionesData]);

  const handleSearchCliente = () => {
    setSearchCliente(true);
  };

  const handleCancelSearchCliente = () => {
    setSearchCliente(false);
  };

  const handleRowClick = (row) => {
    setCliente({ ...cliente, codigoSapCliente: row.row.cod, codigoEspCliente: row.row.cod });
    setSearchCliente(false);
  };

  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const handleChangeDelegacion = (idDelegacion) => {
    const delegacionCod = delegacionesData.filter((d) => d.id === idDelegacion);
    setCodDelegacionStatus(delegacionCod);
    setDelegacionStatus(idDelegacion);
  };

  const handleAccept = () => {
    if (isNew) {
      return onRowClick(cliente);
    } else {
      return onEditRowClick(cliente, rowData?.codigoSapCliente);
    }
  };

  return (
    <CustomDialog
      open={open}
      maxWidth='md'
      fullWidth={true}
      title={isNew ? 'Agregar cliente' : 'Editar cliente'}
      onCancel={searchCliente ? handleCancelSearchCliente : onClose}
      cancelText='Cerrar'
      onAccept={!searchCliente && handleAccept}
      acceptText={isNew ? 'Agregar' : 'Guardar'}>

      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        gap={1}
        spacing={1.5}>

        {searchCliente &&
          <>
            <Grid size={{ xs: 8 }}>
              <div className="grid-title">
                <div>Haz click sobre un cliente para agregarlo y seguir con el formulario</div>
              </div>
            </Grid>
            <Grid size={{ xs: 3.9 }}>
              <TextInput
                placeholder='Filtrar'
                value={filterStatus}
                searchIcon
                onChange={(e) => setFilterStatus(e.target.value)}
                onClearButtonClick={() => setFilterStatus(' ')} />

            </Grid>
            <Grid size={{ xs: 4 }}>
              <SelectInput options={delegacionesData}
                value={delegacionStatus}
                label='Delegación'
                placeHolder='Elige una delegación'
                onChange={(e) => handleChangeDelegacion(e.target.value)} />

            </Grid>

            <Grid size={{ xs: 8 }}>
              <DataGridGenerico
                hideFooterPagination={false}
                toolbar={false}
                columns={columns}
                rows={rows}
                onPageChange={(page) =>
                  handleChangePaginationStatus((prev) => ({
                    ...prev,
                    page: page
                  }))
                }
                onPageSizeChange={(pageSize) =>
                  handleChangePaginationStatus((prev) => ({
                    ...prev,
                    pageSize: pageSize,
                    page: 0
                  }))
                }
                pageSize={paginationStatus.pageSize}
                totalCount={totalCount}
                currentPage={paginationStatus.page}
                onRowClick={(row) => handleRowClick(row)} />

            </Grid>
          </>
        }
      </Grid>

      {!searchCliente &&
        <div className='crearcliente-dialog-content'>
          <div className='grid-agregar-cliente'>
            <Box sx={{ width: '100%' }}>
              <Grid
                container
                justifyContent={'space-between'}
                columns={{
                  xs: 2,
                  md: 4
                }}
                rowGap={1}
                spacing={1.5}>

                <Grid size={{ xs: 2 }}>
                  <TextInput
                    label='Buscar cliente'
                    searchIcon
                    placeholder='Buscar cliente'
                    onClick={handleSearchCliente}
                    value={cliente.codigoSapCliente ?
                      cliente.codigoSapCliente +
                      ' - ' +
                      rows?.find((x) => x.cod == cliente.codigoSapCliente)?.nombre :
                      ''
                    } />

                </Grid>
                <Grid size={{ xs: 2 }}>
                  <TextInput
                    label='Cod. Financiador'
                    placeholder='Codigo financiador'
                    value={cliente.codigoEspCliente}
                    onChange={(e) => setCliente({ ...cliente, codigoEspCliente: e.target.value })} />

                </Grid>
                <Grid size={{ xs: 2.8 }}>
                  <TextInput
                    label='Nombre'
                    placeholder='Nombre'
                    value={cliente.nombre}
                    onChange={(e) => setCliente({ ...cliente, nombre: e.target.value })} />

                </Grid>
                <Grid className='switch-flex-end' size={{ xs: 1.2 }}>
                  <div className='switch-row'>
                    <span>Requeridos para facturas</span>
                    <SwitchInput
                      onChange={(e) => setCliente({ ...cliente, requiereFacturacion: e.target.checked })}
                      checked={cliente.requiereFacturacion} />

                  </div>
                </Grid>
                <Grid size={{ xs: 0.8 }}>
                  <TextInput
                    value={cliente?.atributo1}
                    onChange={(e) => setCliente({ ...cliente, atributo1: e.target.value })}
                    label='Atributo 1'
                    placeholder='Ingresar atributo' />


                </Grid>
                <Grid size={{ xs: 0.8 }}>
                  <TextInput
                    value={cliente?.atributo2}
                    onChange={(e) => setCliente({ ...cliente, atributo2: e.target.value })}
                    label='Atributo 2'
                    placeholder='Ingresar atributo' />

                </Grid>
                <Grid size={{ xs: 0.8 }}>
                  <TextInput
                    value={cliente?.atributo3}
                    onChange={(e) => setCliente({ ...cliente, atributo3: e.target.value })}
                    label='Atributo 3'
                    placeholder='Ingresar atributo' />

                </Grid>
                <Grid size={{ xs: 0.8 }}>
                  <TextInput
                    value={cliente?.atributo4}
                    onChange={(e) => setCliente({ ...cliente, atributo4: e.target.value })}
                    label='Atributo 4'
                    placeholder='Ingresar atributo' />

                </Grid>
                <Grid size={{ xs: 0.8 }}>
                  <TextInput
                    value={cliente?.atributo5}
                    onChange={(e) => setCliente({ ...cliente, atributo5: e.target.value })}
                    label='Atributo 5'
                    placeholder='Ingresar atributo' />

                </Grid>
              </Grid>
            </Box>
          </div>
        </div>
      }
    </CustomDialog>);

};


const useGetClientes = () => {
  const [clientes, setClientes] = useState([]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [delegacionStatus, setDelegacionStatus] = useState('');
  const [codDelegacionStatus, setCodDelegacionStatus] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getClientes, { loading: clientesLoading, data: clientesData }] = useLazyQuery(GET_CLIENTES, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!clientesData) return;
    setClientes(clientesData);
  }, [clientesData])

  useEffect(() => {
    if (!clientesLoading) {
      getClientes({
        variables: {
          skip: (paginationStatus.page * paginationStatus.pageSize),
          take: paginationStatus.pageSize,
          where: {
            or: [
              { nom_com: { contains: debouncedFilterValue?.trim() } },
              { cod_Cliente: { contains: debouncedFilterValue?.trim() } }
            ],
            and: {
              or: codDelegacionStatus?.map((x) => {
                return { cod_Delegacion: { eq: (x.cod) } }
              })
            }
          }
        }
      });
    }
  }, [delegacionStatus, paginationStatus, debouncedFilterValue]);
  return [
    adaptClientesArray(clientes) || [],
    setPaginationStatus,
    paginationStatus,
    clientes?.allPlanesClientes?.totalCount,
    filterStatus,
    setFilterStatus,
    delegacionStatus,
    setDelegacionStatus,
    setCodDelegacionStatus
  ]
}
